import React from 'react';
import ButtonTwo from '../Button/ButtonTwo';

import shapeImg1 from '../../assets/img/slider/shape-1-1.png';
import shapeImg2 from '../../assets/img/slider/shape-1-2.png';
import shapeImg3 from '../../assets/img/slider/shape-1-3.png';
import Image from '../../assets/img/slider/slide-1-1.jpg';

const SingleSlider = (props) => {
  const { itemClass, sliderImage, title, description, btnTextOne, btnTextTwo } =
    props;
  return (
    <div
      className={
        itemClass ? itemClass : 'it-slider-height fix p-relative z-index'
      }
    >
      <div className="it-slider-shape-1">
        <img src={shapeImg2} alt="" />
      </div>
      <div className="it-slider-shape-2">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="it-slider-shape-3">
        <img src={shapeImg3} alt="" />
      </div>
      <div
        className="it-slider-bg"
        style={{ backgroundImage: `url(${sliderImage ? sliderImage : Image})` }}
      ></div>
      <div className="container">
        <div className="row">
          <div className="col-xxl-8 col-xl-8 col-lg-10">
            <div className="it-slider-content">
              <h1 className="it-hero-title text-white pb-10">
                {title
                  ? title
                  : 'Caring Hearts, Healing Hands Our Cardiology Practice'}
              </h1>
              <div className="it-hero-text">
                <p className="text-white">
                  {description
                    ? description
                    : `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation .`}
                </p>
                <div className="it-slider-button mt-35">
                  <ButtonTwo
                    btnURL="/about-us"
                    btnClass="it-btn-theme red-bg mr-35"
                    btnText={btnTextOne ? btnTextOne : 'Read More'}
                  />
                  <ButtonTwo
                    btnURL="/contact"
                    btnClass="it-btn-theme border-btn red-bg"
                    btnText={btnTextTwo ? btnTextTwo : 'Get in Touch'}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleSlider;
